<template>
  <div class="site-wrapper" :style="cssVars">
    <site-header v-if="$store.state.app === 'consignment' && $route.name !== 'download'"/>
    <vendorPortalHeader v-if="$store.state.app === 'consignment-portal' && $route.name !== 'vendorPortalLogin' && $route.name !== 'download' && $route.name !== 'vendorPortalPasswordReset'" :loadLinks="routerLoad"/>
    <salesrepsHeader v-if="$store.state.app === 'salesreps' && $route.name !== 'download'"/>

    <div class="progress-bar-area" v-if="$store.state.app !== 'consignment-portal' && ($store.state.settings.sync_active || $store.state.settings.sync_error)">
      <div class="progress-bar-area--section-area">
        <div class="grid-container">
          <template v-if="$store.state.settings.sync_active">
            <div key="sync-progress-label" id="progress-bar-label" class="progress-bar-label">Syncing...
            </div>

            <div class="progress-bar">
              <span id="progress-bar-progress"></span>
            </div>
          </template>

          <template v-else>
            <div key="sync-error-label" class="progress-bar-label progress-bar-label--error">{{ $store.state.settings.sync_error }}</div>
            <button class="progress-bar-restart" @click="restartSync">Restart sync</button>
          </template>
        </div>
      </div>
    </div>

    <router-view v-if="routerLoad" :key="$route.path"/>

    <div v-if="vendorError !== null">
      <main id="vendor-error" class="site-main">
        <div class="grid-container grid-container--x-small">
          <div class="login-form">
            <div class="panel">
              <p>{{ vendorError }}</p>
            </div>
          </div>
        </div>
      </main>
    </div>

    <site-footer v-if="$route.name !== 'download'"/>

    <tutorialBase v-if="showTutorial && $route.name !== 'download' && $store.state.app !== 'consignment-portal'"
                  @finished="tutorialFinished"></tutorialBase>
    <tutorialBaseAlt v-if="showTutorial2 && $route.name !== 'download' && $store.state.app !== 'consignment-portal'"
                     @finished="tutorialFinished"></tutorialBaseAlt>
    <reviewPopup v-if="showReviewPopup && $route.name !== 'download' && $store.state.app !== 'consignment-portal'"
                  @finished="reviewPopupFinished"></reviewPopup>
  </div>
</template>

<script>
import client from '@/mixins/client'
import '@/scripts/app'

import siteHeader from '@/globals/header'
import vendorPortalHeader from '@/apps/vendorconsignment/vendorPortalHeader'
import salesrepsHeader from '@/apps/salesreps/header'
import siteFooter from '@/globals/footer'
import tutorialBase from '@/apps/vendorconsignment/tutorials/base'
import tutorialBaseAlt from '@/apps/vendorconsignment/tutorials/baseAlt'
import reviewPopup from '@/apps/vendorconsignment/tutorials/reviewPopup'
import { APP } from '@/localSettings'
import moment from 'moment'

export default {
  name: 'site',
  mixins: [client],
  data: function () {
    return {
      app: '',
      routerLoad: false,
      syncActive: true,
      showTutorial: false,
      showTutorial2: false,
      showReviewPopup: false,
      vendorError: null
    }
  },
  components: {
    siteHeader,
    vendorPortalHeader,
    salesrepsHeader,
    siteFooter,
    tutorialBase,
    tutorialBaseAlt,
    reviewPopup
  },
  methods: {
    pollSyncProgress () {
      let checkProgress = setInterval(() => {
        this.request('get', '/sync-progress/', {
          domain: this.$store.state.shop.myshopify_domain
        }).then(response => {
          let label = document.getElementById('progress-bar-label')
          let bar = document.getElementById('progress-bar-progress')

          if (response.description != null && label && bar) {
            if (response.description.length > 0) {
              label.textContent = response.description + '...'
            }

            bar.style.width = response.progress + '%'
          } else if (label) {
            label.textContent = 'Syncing...'
          }

          if (!response.active) {
            clearInterval(checkProgress)

            this.$store.state.settings.sync_active = false
            this.$store.state.settings.sync_error = response.error || ''

            if (!this.$store.state.settings.sync_error) {
              if (label) {
                label.textContent = 'Syncing...'
              }
              if (bar) {
                bar.style.width = 0
              }
            }
          }
        })
      }, 3000)
    },
    restartSync () {
      this.$store.state.settings.sync_error = ''
      this.$store.state.settings.sync_active = true

      this.request('get', '/shop-sync/', {
        domain: this.$store.state.shop.myshopify_domain,
        app_slug: 'vendor-consignment',
        force: true
      }).then(() => {
        this.pollSyncProgress()
      })
    },
    getPortalColor (key) {
      if (this.$store.state.portalSettings !== null) {
        if (this.$store.state.portalSettings[key] && this.$store.state.portalSettings[key].length === 7) {
          return this.$store.state.portalSettings[key]
        }
      }

      return false
    },
    setTutorial () {
      // let currentDate = moment().subtract('days', 3)

      this.showTutorial = true
    },
    tutorialFinished: function () {
      this.showTutorial = false
      this.showTutorial2 = false

      if (this.meta.vendor_consignment_intro === undefined) {
        this.$store.dispatch('createMeta', {
          meta_key: 'vendor_consignment_intro',
          meta_value: true
        })
      } else {
        this.meta.vendor_consignment_intro.meta_value = true

        this.$store.dispatch(
          'updateMeta',
          this.meta.vendor_consignment_intro
        )
      }
    },
    setReviewPopup: function () {
      let currentDate = moment().subtract('days', 14)

      if (currentDate > moment(this.$store.state.shop.created_date)) {
        this.showReviewPopup = true
      }
    },
    reviewPopupFinished: function () {
      this.showReviewPopup = false

      if (this.meta.vendor_consignment_review_popup === undefined) {
        this.$store.dispatch('createMeta', {
          meta_key: 'vendor_consignment_review_popup',
          meta_value: true
        })
      } else {
        this.meta.vendor_consignment_review_popup.meta_value = true

        this.$store.dispatch(
          'updateMeta',
          this.meta.vendor_consignment_review_popup
        )
      }
    },
    checkVendor () {
      this.routerLoad = true
      if (this.$route.name === 'vendorPortalLogin' || this.$route.name === 'download' || this.$route.name === 'vendorPortalPasswordReset') {
        this.routerLoad = true
      } else {
        if (this.$store.state.vendors !== null && this.$store.state.vendors.length > 0) {
          this.routerLoad = true
        } else {
          this.vendorError = 'No vendors associated to your login. Please contact the store owner.'
        }
      }
    },
    appendShopInfoToSupportTicket ($) {
      /* Append app info to Zoho support description field */
      let appName = this.$store.state.app
      let shopifyDomain = null
      let vendorName = null
      let accountEmail = null
      try {
        if (this.$store.state.app === 'consignment-portal') {
          shopifyDomain = this.$store.state.portalSettings.myshopify_domain
          vendorName = this.$store.state.vendors[0].name
          accountEmail = this.$store.state.vendors[0].account_email
        } else {
          shopifyDomain = this.$store.state.shop.myshopify_domain
        }
      } catch (e) {

      }

      setTimeout(function () {
        /* Add short delay to allow Zoho html to render */
        $('#feedbacklabel').on('click', function () {
          let $sbmtBtn = $('#feedbPopupSbmtBtn')
          let $btnContainer = $('.fright.mt5')
          let $feedbackDesc = $('#feedbackDescription')
          $sbmtBtn.remove() // remove original submit button
          let $myBtn = $('<input type="button" value="Submit" class="dt-blue-btn">').on('click', function () {
            /* Do our stuff */
            let appendDomainValue = '\n[app] ' + appName + '\n[domain] ' + shopifyDomain
            if (appName === 'consignment-portal') {
              appendDomainValue += '\n[vendorName] ' + vendorName
              appendDomainValue += '\n[accountEmail] ' + accountEmail
            }
            let feedbackDescVal = $feedbackDesc.val().replace(appendDomainValue, '')
            $feedbackDesc.val(feedbackDescVal + appendDomainValue)
            /* Now invoke original button after slight delay */
            setTimeout(function () { $sbmtBtn.click() }, 50)
          })
          $btnContainer.append($myBtn) // add in alternative submit button
        })
      }, 150)
    }
  },
  computed: {
    shop () {
      return this.$store.state.shop
    },
    meta () {
      return this.$store.state.metas
    },
    primaryColor () {
      let color = '#eb008c'

      if (this.getPortalColor('vendor_portal_primary_color') !== false) {
        color = this.getPortalColor('vendor_portal_primary_color')
      }

      return color
    },
    secondaryColor () {
      let color = '#7101a5'

      if (this.getPortalColor('vendor_portal_secondary_color') !== false) {
        color = this.getPortalColor('vendor_portal_secondary_color')
      }

      return color
    },
    buttonTextColor () {
      let color = '#ffffff'

      if (this.getPortalColor('vendor_portal_button_text_color') !== false) {
        color = this.getPortalColor('vendor_portal_button_text_color')
      }

      return color
    },
    cssVars () {
      /* eslint-disable */
      const pSBC=(p,c0,c1,l)=>{
        let r,g,b,P,f,t,h,i=parseInt,m=Math.round,a=typeof(c1)=="string";
        if(typeof(p)!="number"||p<-1||p>1||typeof(c0)!="string"||(c0[0]!='r'&&c0[0]!='#')||(c1&&!a))return null;
        if(!this.pSBCr)this.pSBCr=(d)=>{
          let n=d.length,x={};
          if(n>9){
            [r,g,b,a]=d=d.split(","),n=d.length;
            if(n<3||n>4)return null;
            x.r=i(r[3]=="a"?r.slice(5):r.slice(4)),x.g=i(g),x.b=i(b),x.a=a?parseFloat(a):-1
          }else{
            if(n==8||n==6||n<4)return null;
            if(n<6)d="#"+d[1]+d[1]+d[2]+d[2]+d[3]+d[3]+(n>4?d[4]+d[4]:"");
            d=i(d.slice(1),16);
            if(n==9||n==5)x.r=d>>24&255,x.g=d>>16&255,x.b=d>>8&255,x.a=m((d&255)/0.255)/1000;
            else x.r=d>>16,x.g=d>>8&255,x.b=d&255,x.a=-1
          }return x};
        h=c0.length>9,h=a?c1.length>9?true:c1=="c"?!h:false:h,f=this.pSBCr(c0),P=p<0,t=c1&&c1!="c"?this.pSBCr(c1):P?{r:0,g:0,b:0,a:-1}:{r:255,g:255,b:255,a:-1},p=P?p*-1:p,P=1-p;
        if(!f||!t)return null;
        if(l)r=m(P*f.r+p*t.r),g=m(P*f.g+p*t.g),b=m(P*f.b+p*t.b);
        else r=m((P*f.r**2+p*t.r**2)**0.5),g=m((P*f.g**2+p*t.g**2)**0.5),b=m((P*f.b**2+p*t.b**2)**0.5);
        a=f.a,t=t.a,f=a>=0||t>=0,a=f?a<0?t:t<0?a:a*P+t*p:0;
        if(h)return"rgb"+(f?"a(":"(")+r+","+g+","+b+(f?","+m(a*1000)/1000:"")+")";
        else return"#"+(4294967296+r*16777216+g*65536+b*256+(f?m(a*255):0)).toString(16).slice(1,f?undefined:-2)
      }

      return {
        '--primary-color': this.primaryColor,
        '--primary-dark-color': pSBC(-.2, this.primaryColor),
        '--secondary-color': this.secondaryColor,
        '--font-color': this.fontColor,
        '--button-text-color': this.buttonTextColor
      }
    }
  },
  mounted () {
    if (this.$route.name !== 'download' && APP !== 'consignment-portal') {
      const zohoScript = document.createElement('script')
      zohoScript.setAttribute('src', 'https://desk.zoho.com/portal/api/feedbackwidget/680199000000184304?orgId=767537906&displayType=popout')
      zohoScript.setAttribute('text', 'text/javascript')
      // zohoScript.setAttribute('async', 'async')
      // zohoScript.setAttribute('defer', 'defer')
      document.head.appendChild(zohoScript)

      zohoScript.onload = () => {
        this.appendShopInfoToSupportTicket($)
      }

      this.$nextTick(function () {
        window.setInterval(() => {
          if (this.$route.name !== 'privacyPolicy' && this.$route.name !== 'termsService') {
            if (this.$store.state.metas.vendor_consignment_intro !== undefined) {
              if (!this.$store.state.metas.vendor_consignment_intro.meta_value) {
                this.setTutorial()
              }
            } else {
              this.setTutorial()
            }
          } else {
            this.showTutorial = false
            this.showTutorial2 = false
          }

          // if (this.$store.state.metas.vendor_consignment_review_popup !== undefined) {
          //   if (!this.$store.state.metas.vendor_consignment_review_popup.meta_value) {
          //     this.setReviewPopup()
          //   }
          // }
        }, 100)
      })
    }
  },
  created () {
    if (this.$route.name !== 'download' && APP !== 'consignment-portal') {
      this.routerLoad = true

      if (this.$store.state.settings.sync_active) {
        this.pollSyncProgress()
      }
    } else {
      if (this.$store.state.portalSettings && this.$store.state.portalSettings['vendor_portal_css']) {
        let style = document.createElement('style')
        style.innerHTML = this.$store.state.portalSettings['vendor_portal_css']
        document.head.appendChild(style)
      }

      this.checkVendor()
    }
  }
}
</script>

<style lang="scss">
/*@import 'styles/app';*/

.section-page .progress-bar-area--section-area {
  padding-left: 200px;
}

.progress-bar-label--error {
  color: #b00020;
  font-weight: 600;
}

.progress-bar-restart {
  margin-top: 8px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/App.vue